<template>
  <v-flex xs12>
    <v-card>
      <v-layout row wrap justify-space-between align-center class="px-2 pt-4">
        <v-flex xs12 sm6 px-3>
          <v-text-field
            v-model="report.type"
            :label="$lang.labels.type"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm6 px-3>
          <v-text-field
            v-model="report.companyName"
            :label="$lang.labels.companyName"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm6 px-3>
          <v-text-field
            v-model="report.month"
            :label="$lang.labels.month"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm6 px-3>
          <v-text-field
            v-model="report.year"
            :label="$lang.labels.year"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm6 px-3>
          <v-text-field
            v-model="report.createdOn"
            :label="$lang.labels.created"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm6 px-3>
          <v-text-field
            v-model="report.modifiedOn"
            :label="$lang.labels.modified"
            readonly
          />
        </v-flex>
      </v-layout>
      <v-flex px-4 py-4>
        <hr>
      </v-flex>
      <h3 class="mx-4">{{$lang.header.paymentSummary}}</h3>
      <v-data-table
        class="my-table-paymentSummary text-xs-left"
        :items="paymentSummary"
        hide-actions
        v-if="paymentSummary"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th class="text-xs-left ml-3">{{$lang.header.paymentType}}</th>
            <th class="text-xs-left ml-3">{{$lang.header.amount}}</th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ $lang.labels[props.item.paymentType] }}</td>
          <td class="text-xs-left">{{ props.item.amount }}</td>
        </template>
      </v-data-table>
      <h3 class="mx-4 pt-4">{{$lang.header.webShops}}</h3>
      <v-data-table
        class="my-table"
        :items="report.webShopResources"
        hide-actions
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th class="bottomHeader column text-xs-left">{{$lang.header.webShopResourceId}}</th>
            <th class="bottomHeader column text-xs-center">{{$lang.header.paymentSummary}}</th>
            <th class="customHeader">
              <td class="topHeader">{{$lang.header.webshop}}</td>
              <td class="bottomHeader column text-xs-center" role="columnheader" scope="col">{{$lang.license.orders}}</td>
            </th>
            <th class="bottomHeader column" role="columnheader" scope="col">{{$lang.license.totalAmount}}</th>
            <th class="customHeader">
              <td class="topHeader text-xs-center">{{$lang.header.orderingApp}}</td>
              <td class="bottomHeader column text-xs-center" role="columnheader" scope="col">{{$lang.license.orders}}</td>
            </th>
            <th class="bottomHeader column text-xs-center" role="columnheader" scope="col">{{$lang.license.totalAmount}}</th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <td>{{ props.item.webShopResourceId }}</td>
          <td v-if="props.item.paymentSummary" class="text-xs-center">
            <template v-for="type in props.item.paymentSummary">
              <span>{{ $lang.labels[type.paymentType] }}: {{ type.amount }}</span><br>
            </template>
          </td>
          <td v-else class="text-xs-center">-</td>
          <td v-if="props.item.ordersData" class="text-xs-center">{{ props.item.ordersData.webshop ? props.item.ordersData.webshop.noOfOrders : '-' }}</td>
          <td v-else class="text-xs-center">-</td>
          <td v-if="props.item.ordersData" class="text-xs-center">{{ props.item.ordersData.webshop ? props.item.ordersData.webshop.ordersSum : '-' }}</td>
          <td v-else class="text-xs-center">-</td>
          <td v-if="props.item.ordersData" class="text-xs-center">{{ props.item.ordersData['ordering app'] ? props.item.ordersData['ordering app'].noOfOrders : '-' }}</td>
          <td v-else class="text-xs-center">-</td>
          <td v-if="props.item.ordersData" class="text-xs-center">{{ props.item.ordersData['ordering app'] ? props.item.ordersData['ordering app'].ordersSum : '-' }}</td>
          <td v-else class="text-xs-center">-</td>
        </template>
      </v-data-table>
      <v-btn
        flat class="mx-3"
        @click="$emit('close')">
        <v-icon>keyboard_arrow_left</v-icon>
        {{$lang.actions.close}}
      </v-btn>
    </v-card>
  </v-flex>
</template>

<script>
  import {DateTime} from 'luxon';

  export default {
    props: ['reportDetails'],
    data() {
      return {
        report: {
          type: '',
          companyName: '',
          month: '',
          year: '',
          createdOn: '',
          modifiedOn: '',
        },
        headers: [
          { text: this.$lang.header.webShopResourceId, value: 'webShopResourceId', align: 'left', },
          { text: this.$lang.header.noOfOrders, value: 'noOfOrders', align: 'left', },
          { text: this.$lang.header.ordersSum, value: 'ordersSum', align: 'left', },
        ],
        paymentSummary: null,
      };
    },
    methods: {
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd HH:mm');
      },
      calculatePaymentSummary(report) {
        const helper = {};
        this.paymentSummary = report.reduce(function (r, o) {
          const key = o.paymentType;

          if (!helper[key]) {
            helper[key] = Object.assign({}, o);
            r.push(helper[key]);
          } else {
            helper[key].amount += o.amount;
          }

          return r;
        }, []);
      }
    },
    created() {
      this.$http.get(`report/${this.reportDetails.id}`)
        .then((res) => {
          if (res.body.status === 'Success') {
            const report = res.body.report;
            report.createdOn = this.formatDate(report.createdOn);
            report.modifiedOn = this.formatDate(report.modifiedOn);
            this.report = report;
            this.calculatePaymentSummary(report.webShopResources.map(x => x.paymentSummary).flat(Infinity));
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
    },
  };
</script>

<style lang="scss">
  .my-table thead {
    th {
      padding: 0 12px !important;
      opacity: .75 !important;
    }
    .topHeader {
      position: absolute;
      top: 8px;
      font-size: 15px;
      right: -48%;
      width: 100%;
    }
    .bottomHeader {
      padding: 18px 24px 0 24px !important;
    }
  }
  .my-table thead th:first-of-type {
    width: 20px !important;
  }
  .my-table {
    border: 1px solid rgba(0,0,0,.12) !important;
    .customHeader {
      position: relative;
      padding: 0 !important;
      td.bottomHeader {
        padding: 18px 24px 0 24px !important;
        display: block;
      }
    }
    thead tr:first-of-type {
      height: 60px !important;
    }
  }
  .my-table-paymentSummary thead th:first-of-type {
    width: 30px !important;
  }
  .my-table-paymentSummary {
    border: 1px solid rgba(0,0,0,.12) !important;
  }
</style>



// WEBPACK FOOTER //
// WebshopReportsModal.vue?69f9bd7c